import React from "react"
import classnames from "classnames"
import styles from "./LoadingIcon.less"

const LoadingIcon = ({ style, styleName = "light" }) => {
  return (
    <div
      className={classnames({
        [styles.LoadingIcon]: true,
        [styles.LoadingIconLight]: styleName === "light",
        [styles.LoadingIconDark]: styleName === "dark"
      })}
      style={style} />
  )
}

export default LoadingIcon




// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/LoadingIcon/LoadingIcon.jsx